export default __webpack_public_path__ + "static/media/XII_Old_Black.3d339f80.png";